const WHATSAPP_URL = 'https://wa.me/5585982245030?text=Olá!%20Vim%20pelo%20site%20da%20Naturalle%20Sanduíches%20e%20gostaria%20de%20mais%20informações.';

export default function FloatingWhatsApp() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-500 text-white hover:scale-110 hover:bg-accent-600 transition-all duration-300 animate-float"
      aria-label="Fale pelo WhatsApp"
      style={{ boxShadow: '0 8px 32px rgba(196,125,94,0.35)' }}
    >
      <i className="ri-whatsapp-line text-2xl md:text-3xl"></i>
      <span className="absolute -top-1 -right-1 w-4 h-4 bg-primary-400 rounded-full border-2 border-background-50">
        <span className="block w-full h-full bg-primary-400 rounded-full animate-pulse"></span>
      </span>
    </a>
  );
}